import { render, staticRenderFns } from "./User-menu-side.vue?vue&type=template&id=89688662&"
import script from "./User-menu-side.vue?vue&type=script&lang=js&"
export * from "./User-menu-side.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports